module.exports = __webpack_public_path__ + "static/media/fleet-contact.1ba50e78.jpg";